module.exports = __webpack_public_path__ + "static/media/Novarese_Bold.2faf2f7b.svg";